<template>
  <div class="col-lg-4 col-md-6 box-col-4">
    <div class="card profit-card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1">
            <p class="square-after f-w-600 header-text-primary">
              Total de Ventas en el mes<i class="fa fa-circle"> </i>
            </p>
            <h4>{{ formattedTotalVentas }}</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="profit-wrapper header-text-primary icon-bg-primary">
              <i :class="trendIconClass"></i>
            </div>
            <h6 class="header-text-primary">{{ formattedTrendPercentage }}</h6>
            <p class="mb-0">{{ trendLabel }}</p>
          </div>
        </div>
        <div class="right-side icon-right-primary">
          <i class="fa fa-usd"></i>
          <div class="shap-block">
            <div class="rounded-shap animate-bg-primary"><i></i><i></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfitCard',
  props: {
    totalVentas: {
      type: Number,
      default: 0,
    },
    trendPercentage: {
      type: Number,
      default: 0,
    },
    trendLabel: {
      type: String,
      default: 'Más que el mes pasado',
    },
  },
  computed: {
    formattedTotalVentas() {
      const value = Number.isFinite(this.totalVentas)
        ? this.totalVentas
        : parseFloat(this.totalVentas || 0) || 0

      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
    },
    formattedTrendPercentage() {
      const value = Number(this.trendPercentage)
      if (Number.isFinite(value)) {
        return `${value.toFixed(2)}%`
      }
      return '0.00%'
    },
    trendIconClass() {
      const value = Number(this.trendPercentage) || 0
      return value < 0 ? 'fa fa-arrow-right' : 'fa fa-arrow-up'
    },
  },
}
</script>
